import { STATUS_COLOURS, StatusColour } from '../../fundamentals/colours/variants';
import { IAlertState } from '../../hooks/useAlertState/useAlertState';

export type AlertGroup = {
  [key in StatusColour]: IAlertState[];
};

const alertVariantPriority = Object.values(STATUS_COLOURS);

export const groupByVariant = (alerts: IAlertState[]): IAlertState[][] => {
  const sortedAlerts: IAlertState[][] = [];

  const alertGroups = alerts.reduce((group, alert) => {
    const { variant = STATUS_COLOURS.NEUTRAL } = alert;
    group[variant] = group[variant] ?? [];
    group[variant].push(alert);
    return group;
  }, {} as AlertGroup);

  alertVariantPriority.forEach((variant) => {
    if (alertGroups[variant]) {
      sortedAlerts.push(alertGroups[variant]);
    }
  });
  return sortedAlerts;
};
